import React, { FC } from 'react';
import { useBackgroundContext } from '../BackgroundProvider';
import styles from './Header.css';
import { useApplicationContext } from '../../utils/applicationContext';

export const Header: FC<React.PropsWithChildren> = ({ children }) => {
  const [backgroundImg] = useBackgroundContext();

  const { config } = useApplicationContext();

  const suburbanRKTitle = config.get<string>('suburbanRK.title');

  return (
    <div className={styles['header']} style={{ backgroundImage: `url(${backgroundImg})` }} data-name="HeaderBlock">
      <div className={styles['content']}>
        <div className={styles['inner']}>
          <div className={styles['title']}>{suburbanRKTitle || 'Дома, дачи и участки'}</div>
          {children}
        </div>
        {!suburbanRKTitle && <div className={styles['overlay']} />}
      </div>
    </div>
  );
};
